<!-- @format -->

<a
	*ngIf="data"
	[href]="data.link"
	[attr.data-em]="createDealTag(drawer, data.message)"
	class="deal-block">
	<span
		class="deal-image {{ data.dealTypeClass }}"
		[ngClass]="{ badged: data.dealType && data.dealType !== 'None' }">
		<shared-media-component-media
			*ngIf="data.image || data.visualAssets"
			[visualAssets]="data.visualAssets"
			[image]="data.image"
			[itemTitle]="data.dealType || ''"
			[altText]="''"
			[willLazyLoad]="true">
		</shared-media-component-media>
		<homefield-icon
			class="homefield-icons"
			*ngIf="data.dealType && data.dealType === 'Doorbuster'"
			name="nature-hot"></homefield-icon>
		<homefield-icon
			class="homefield-icons"
			*ngIf="data.dealType && data.dealType === 'Limited Time'"
			name="time-alarm-on"></homefield-icon>
		<svg
			*ngIf="data.dealType === 'Deal of the Day'"
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<rect
				width="24"
				height="24" />
			<path
				d="M12 5C8.136 5 5 8.136 5 12C5 15.864 8.136 19 12 19C15.864 19 19 15.864 19 12C19 11.188 18.853 10.383 18.573 9.627L17.453 10.747C17.551 11.16 17.6 11.58 17.6 12C17.6 15.094 15.094 17.6 12 17.6C8.906 17.6 6.4 15.094 6.4 12C6.4 8.906 8.906 6.4 12 6.4C12.42 6.4 12.84 6.449 13.253 6.547L14.38 5.42C13.617 5.147 12.812 5 12 5ZM16.9 5L14.1 7.8V8.85L12.315 10.635C12.21 10.6 12.105 10.6 12 10.6C11.23 10.6 10.6 11.23 10.6 12C10.6 12.77 11.23 13.4 12 13.4C12.77 13.4 13.4 12.77 13.4 12C13.4 11.895 13.4 11.79 13.365 11.685L15.15 9.9H16.2L19 7.1H16.9V5ZM12 7.8C9.683 7.8 7.8 9.683 7.8 12C7.8 14.317 9.683 16.2 12 16.2C14.317 16.2 16.2 14.317 16.2 12H14.8C14.8 13.547 13.547 14.8 12 14.8C10.453 14.8 9.2 13.547 9.2 12C9.2 10.453 10.453 9.2 12 9.2V7.8Z"
				fill="white" />
		</svg>
		<svg
			*ngIf="data.dealType === 'Gift of the Day'"
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<rect
				width="24"
				height="24" />
			<g clip-path="url(#clip0)">
				<path
					d="M19.2727 12.2727V18.0909C19.2727 18.8909 18.6182 19.5455 17.8182 19.5455H6.18182C5.38182 19.5455 4.72727 18.8909 4.72727 18.0909V12.2727C4.32727 12.2727 4 11.9455 4 11.5455V9.36364C4 8.56364 4.65455 7.90909 5.45455 7.90909H7.76C7.68 7.67636 7.63636 7.42909 7.63636 7.18182C7.63636 5.97455 8.61091 5 9.81818 5C10.5455 5 11.1855 5.36364 11.5855 5.90182V5.89455L12 6.45455L12.4145 5.89455V5.90182C12.8145 5.36364 13.4545 5 14.1818 5C15.3891 5 16.3636 5.97455 16.3636 7.18182C16.3636 7.42909 16.32 7.67636 16.24 7.90909H18.5455C19.3455 7.90909 20 8.56364 20 9.36364V11.5455C20 11.9455 19.6727 12.2727 19.2727 12.2727ZM6.18182 18.0909H11.2727V12.2727H6.18182V18.0909ZM17.8182 18.0909V12.2727H12.7273V18.0909H17.8182ZM9.81818 6.45455C9.41818 6.45455 9.09091 6.78182 9.09091 7.18182C9.09091 7.58182 9.41818 7.90909 9.81818 7.90909C10.2182 7.90909 10.5455 7.58182 10.5455 7.18182C10.5455 6.78182 10.2182 6.45455 9.81818 6.45455ZM14.1818 6.45455C13.7818 6.45455 13.4545 6.78182 13.4545 7.18182C13.4545 7.58182 13.7818 7.90909 14.1818 7.90909C14.5818 7.90909 14.9091 7.58182 14.9091 7.18182C14.9091 6.78182 14.5818 6.45455 14.1818 6.45455ZM5.45455 9.36364V10.8182H11.2727V9.36364H5.45455ZM12.7273 9.36364V10.8182H18.5455V9.36364H12.7273Z"
					fill="white" />
			</g>
			<defs>
				<clipPath id="clip0">
					<rect
						width="16"
						height="14.5455"
						fill="white"
						transform="translate(4 5)" />
				</clipPath>
			</defs>
		</svg>
	</span>
	<p class="deal-message">{{ data.message }}</p>
	<p
		class="deal-tag-type {{ data.dealTypeClass }}"
		*ngIf="data.dealType !== 'None'">
		<span>
			<homefield-icon
				*ngIf="data.dealType === 'Doorbuster'"
				class="homefield-icons"
				name="nature-hot"></homefield-icon>
			<homefield-icon
				*ngIf="data.dealType === 'Limited Time'"
				class="homefield-icons"
				name="time-alarm-on"></homefield-icon>
			<svg
				*ngIf="data.dealType === 'Deal of the Day'"
				width="16"
				height="16"
				viewBox="0 0 16 16"
				fill="none"
				xmlns="http://www.w3.org/2000/svg">
				<path
					d="M8 2C4.688 2 2 4.80487 2 8.26087C2 11.7169 4.688 14.5217 8 14.5217C11.312 14.5217 14 11.7169 14 8.26087C14 7.53461 13.874 6.81461 13.634 6.13843L12.674 7.14017C12.758 7.50957 12.8 7.88522 12.8 8.26087C12.8 11.0282 10.652 13.2696 8 13.2696C5.348 13.2696 3.2 11.0282 3.2 8.26087C3.2 5.49357 5.348 3.25217 8 3.25217C8.36 3.25217 8.72 3.296 9.074 3.38365L10.04 2.37565C9.386 2.13148 8.696 2 8 2ZM12.2 2L9.8 4.50435V5.44348L8.27 7.04C8.18 7.0087 8.09 7.0087 8 7.0087C7.34 7.0087 6.8 7.57217 6.8 8.26087C6.8 8.94956 7.34 9.51304 8 9.51304C8.66 9.51304 9.2 8.94956 9.2 8.26087C9.2 8.16696 9.2 8.07304 9.17 7.97913L10.7 6.38261H11.6L14 3.87826H12.2V2ZM8 4.50435C6.014 4.50435 4.4 6.18852 4.4 8.26087C4.4 10.3332 6.014 12.0174 8 12.0174C9.986 12.0174 11.6 10.3332 11.6 8.26087H10.4C10.4 9.64452 9.326 10.7652 8 10.7652C6.674 10.7652 5.6 9.64452 5.6 8.26087C5.6 6.87722 6.674 5.75652 8 5.75652V4.50435Z"
					fill="white" />
			</svg>
			<svg
				*ngIf="data.dealType === 'Gift of the Day'"
				width="16"
				height="16"
				viewBox="0 0 16 16"
				fill="none"
				xmlns="http://www.w3.org/2000/svg">
				<path
					d="M14.0608 8.06061V12.9091C14.0608 13.5758 13.5153 14.1212 12.8486 14.1212H3.15168C2.48501 14.1212 1.93956 13.5758 1.93956 12.9091V8.06061C1.60622 8.06061 1.3335 7.78788 1.3335 7.45455V5.63636C1.3335 4.9697 1.87895 4.42424 2.54562 4.42424H4.46683C4.40016 4.2303 4.3638 4.02424 4.3638 3.81818C4.3638 2.81212 5.17592 2 6.18198 2C6.78804 2 7.32138 2.30303 7.65471 2.75152V2.74545L8.00016 3.21212L8.34562 2.74545V2.75152C8.67895 2.30303 9.21228 2 9.81835 2C10.8244 2 11.6365 2.81212 11.6365 3.81818C11.6365 4.02424 11.6002 4.2303 11.5335 4.42424H13.4547C14.1214 4.42424 14.6668 4.9697 14.6668 5.63636V7.45455C14.6668 7.78788 14.3941 8.06061 14.0608 8.06061ZM3.15168 12.9091H7.3941V8.06061H3.15168V12.9091ZM12.8486 12.9091V8.06061H8.60622V12.9091H12.8486ZM6.18198 3.21212C5.84865 3.21212 5.57592 3.48485 5.57592 3.81818C5.57592 4.15152 5.84865 4.42424 6.18198 4.42424C6.51531 4.42424 6.78804 4.15152 6.78804 3.81818C6.78804 3.48485 6.51531 3.21212 6.18198 3.21212ZM9.81835 3.21212C9.48501 3.21212 9.21228 3.48485 9.21228 3.81818C9.21228 4.15152 9.48501 4.42424 9.81835 4.42424C10.1517 4.42424 10.4244 4.15152 10.4244 3.81818C10.4244 3.48485 10.1517 3.21212 9.81835 3.21212ZM2.54562 5.63636V6.84848H7.3941V5.63636H2.54562ZM8.60622 5.63636V6.84848H13.4547V5.63636H8.60622Z"
					fill="white" />
			</svg>
			{{ data.dealType }}
		</span>
	</p>
</a>
